// extracted by mini-css-extract-plugin
export default {"archive":"Archive_archive__+oSw0","archive__heading":"Archive_archive__heading__jOjnq"};